import React from 'react';
import ProgressIndicator from '@/components/ui/ProgressIndicator';
import { useOnboarding } from './OnboardingContext';

const CATEGORIES = [
  { id: 'about_you',   label: 'About you',       stepIds: ['about', 'intent'] },
  { id: 'background',  label: 'Your background',  stepIds: ['educator_subjects', 'partner_expertise'] },
  { id: 'location',    label: 'Location & Site',  stepIds: ['zipcode', 'site'] },
];

export default function OnboardingProgress() {
  const { activeStep, completeSteps } = useOnboarding();

  if (!activeStep) return null;

  return (
    <div className="sticky z-10 top-0 bg-white w-full max-w-5xl px-6 lg:px-16 pt-4 lg:pt-16 pb-4">
      <ProgressIndicator
        steps={CATEGORIES}
        activeStepId={activeStep.id}
        completedStepIds={completeSteps}
      />
    </div>
  );
}
